module.exports = __webpack_public_path__ + "media/images/bar_five-0f30724c5868d97f46d3eeb0cc6284c6.png";